const piConnectionEn = {
	piConnectionEditForm: 'PI Connection',
	piConnectionTable: 'PI Connection',
	name: 'Name',
	apiUrl: 'API URL',
	username: 'Username',
	password: 'Password',
	serverId: 'Server ID'
};

export default piConnectionEn;
